import React, {Component} from 'react';
import {FaIcon} from "../FaIcon";

export class BusinessUnitShowAdAccountsOrCampaignsTooltip extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isShowing: this.props.isShowing,
        };
        this.handleClick = this.handleClick.bind(this);
    }

    iconName() {
        return this.state.isShowing ? "minus-square" : "plus-square";
    }

    render() {
        // Con esto hacemos que no se muestre nada sino esta enabled. Si se saca este if, el comportamiento es otro
        // y funciona bien. Pone el icono en gris mostrando un tooltip y no es clickeable
        if(!this.props.enabled)
            return null;

        return (
            <div className="bu-cell-button">
                <button className={this.cssClassName()} onClick={this.handleClick}>
                    <FaIcon type="button" iconName={this.iconName()}/>
                </button>
                {this.renderTooltip()}
            </div>
        )
    }

    renderTooltip() {
        if(this.props.message)
            return (
                <div className="bu-tooltip">
                    <button className={this.cssClassName()} onClick={this.handleClick}>
                        <FaIcon type="button" iconName={this.iconName()}/>
                    </button>
                    <p className="tooltip-description">
                        {this.props.message}
                    </p>
                </div>
            );
    }

    handleClick() {
        if (!this.props.enabled)
            return;
        this.setState({isShowing: !this.state.isShowing});
        this.props.onClick();
    }

    cssClassName() {
        if (this.props.enabled) {
            return "enabled";
        } else {
            return "not-enabled";
        }
    }
}
